export const ALL_QUIZ_QUESTION_TYPES = ['quiz', 'quiz_open'];
